import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Screen } from "./screens/Screen";
import { ROOT_URL, WS_URL } from "./config/url";
import {ViewerProvider} from "./components/Viewer";
import {Kabinet} from "./components/ui";

function App() {
  return (
    <Kabinet rootUrl={ROOT_URL} wsUrl={WS_URL}>
      <ViewerProvider>
        <BrowserRouter>
          <Screen />
        </BrowserRouter>
      </ViewerProvider>
    </Kabinet>
  );
}

export default App;
